/**
 * The shift columns are DATETIME in the database but only the time
 * component matters for availability. TimeInput produces 'HH:mm';
 * anchor it to a fixed date so the API stores a valid datetime.
 */
export const normalizeShiftTimes = (data: Record<string, any>): Record<string, any> => {
  const anchor = (value: unknown): unknown => {
    if (typeof value === 'string' && /^\d{2}:\d{2}(:\d{2})?$/.test(value)) {
      return `2026-01-01 ${value.length === 5 ? `${value}:00` : value}`;
    }
    return value;
  };
  return {
    ...data,
    start_shift: anchor(data.start_shift),
    end_shift: anchor(data.end_shift),
  };
};
